import { render, staticRenderFns } from "./FamousLifeStory.vue?vue&type=template&id=326ce845&"
import script from "./FamousLifeStory.vue?vue&type=script&lang=js&"
export * from "./FamousLifeStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports